import { render, staticRenderFns } from "./user_edit.vue?vue&type=template&id=5dcfe64a&scoped=true&"
import script from "./user_edit.vue?vue&type=script&lang=js&"
export * from "./user_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcfe64a",
  null
  
)

export default component.exports